class _SubviewRemover
  constructor: ->
    @viewsToBeRemoved = []
    @scheduled = null

  enqueue: (subviews) ->
    for view in subviews
      view.$el.detach()
      @viewsToBeRemoved.push(view)
    if @scheduled == null
      @scheduled = setInterval(@processQueue.bind(@), 10)

  processQueue: ->
    startTime = Date.now()
    count = 0
    while Date.now() - startTime < 10 && @viewsToBeRemoved.length > 0
      view = @viewsToBeRemoved.shift()
      view.remove()
      count++
    if @viewsToBeRemoved.length == 0
      clearInterval(@scheduled)
      @scheduled = null

module.exports = SubviewRemover = new _SubviewRemover()
